import type { Feature } from '@luna/gatekeeper';

export const cardMigrationExternal: Feature = {
    enabled: true,
    _description: 'Enables card migration section under services',
};
